import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import {
  Button, Grid, TextField
} from '@material-ui/core'

import { updateAup, getAupList } from '../../../../redux/actions'

import { handleAupParser, handleTextPrepper, handleAupContent } from '../../../../utils'

import { NotificationToast } from '../../tools/Toast'

import { useQuill } from 'react-quilljs'
import 'quill/dist/quill.snow.css'

/**
 * Returns AUP edit form
 */
const AUPedit = ({
  theme, modules, formats, aupName, aupHtml,
  aupID, onBackTrack, classes, textClasses
}) => {
  const dispatch = useDispatch()

  const [newAupName, setNewAupName] = useState('')

  const initAupQuill = useQuill({ theme, modules, formats })
  const aupQuill = initAupQuill.quill
  const aupQuillRef = initAupQuill.quillRef

  useEffect(() => {
    if (aupHtml && aupQuill) {
      const aupQuillContent = handleAupParser(aupHtml)
      aupQuill.setContents(aupQuillContent)
      // aupQuill.enable(false)
    }
  }, [aupQuill, aupHtml])

  useEffect(() => {
    if (aupName) {
      setNewAupName(aupName)
    }
  }, [aupName])

  const handleSave = async () => {
    const preppedAupName = handleTextPrepper(newAupName)
    let aupContents = []
    let aupText = ''
    if (aupHtml && aupQuill) {
      const aupQuillLength = aupQuill.getLength()
      aupContents = aupQuill.getContents(0, aupQuillLength).ops
      aupText = aupQuill.getText(0, aupQuillLength)
    }
    if (aupContents.length !== 0) {
      const aupSendContent = handleAupContent(aupContents)
      const aupSendText = handleTextPrepper(aupText)

      dispatch(updateAup(aupID, preppedAupName, aupSendContent, aupSendText, fireSuccess, fireFailure))
    }
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Successfully updated AUP!')
    dispatch(getAupList())
    onBackTrack()
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to update AUP.')
  }

  return (
    <>
      <Button
        className={`${classes.greenBtn} mt-1 mb-4`}
        onClick={(e) => { e.preventDefault(); onBackTrack() }}
        variant='contained'
      >
        <span className='font-weight-bold'>Back</span>
      </Button>
      <Grid item container direction='row'>
        <Grid item container direction='column' sm={8}>
          <h2 className='mb-4'>
            Edit {newAupName}
          </h2>
        </Grid>
        <Grid item container direction='column' sm={4}>
          <Grid item container direction='row' className='justify-content-end'>
            <Button
              className={`${classes.saveBtn} mt-2`}
              onClick={(e) => { e.preventDefault(); handleSave() }}
              variant='contained'
            >
              <span className='font-weight-bold'>Save</span>
            </Button>
          </Grid>
        </Grid>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' className='mt-2'>
            <Grid item container direction='column' sm={8}>
              <h5>Name</h5>
              <TextField
                value={newAupName}
                onChange={e => setNewAupName(e.target.value)}
                placeholder='Policy Name'
                name='aupName'
                id='aupName'
                error={newAupName.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>
          </Grid>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={12}>
              <div className='mb-5' style={{ height: 300 }}>
                <div ref={aupQuillRef} />
              </div>
            </Grid>
          </Grid>
          <Grid item container direction='column' sm={12}>
            <Grid item container direction='row' className='justify-content-end'>
              <Button
                className={`${classes.saveBtn} mt-3`}
                onClick={(e) => { e.preventDefault(); handleSave() }}
                variant='contained'
              >
                <span className='font-weight-bold'>Save</span>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default AUPedit
